module.exports = __webpack_public_path__ + "img/PrivacyAwarenessCurriculum2023.7a10d7a8.jpg";